// Этот файл генерируется автоматически, его не следует редактировать вручную
import autoheight from '@/widgets/autoheight.js';
import faqManager from '@/widgets/faqManager.js';
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import openByGlobalEvents from '@/widgets/openByGlobalEvents.js';
import scrollTop from '@/widgets/scrollTop.js';
import telField from '@/widgets/telField.js';

export default {
  'autoheight': async () => { return { default: autoheight }; },
  'clientsSlider': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/clientsSlider.js'),
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'faqManager': async () => { return { default: faqManager }; },
  'form': async () => { return { default: form }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'map': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/map.js'),
  'openByGlobalEvents': async () => { return { default: openByGlobalEvents }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'servicesSlider': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/servicesSlider.js'),
  'telField': async () => { return { default: telField }; }
};
